import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { PaymentSubscriptionsIcon } from 'foundations-assets/icons/components/PaymentSubscriptionsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ZeroState = ({
  openPaymentTab
}) => /*#__PURE__*/_jsxs(Button, {
  "data-test-id": "payment-zero-state-button",
  onClick: openPaymentTab,
  use: "tertiary-light",
  children: [/*#__PURE__*/_jsx(PaymentSubscriptionsIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'editor.options.payment.leftEditor.noPaymentLinks'
  })]
});
export default ZeroState;